import React, { Component } from 'react';
import classNames from 'classnames';
import ReactDataGrid from 'react-data-grid';
import ReactDOM from 'react-dom';
import { Toolbar, Data, Editors, Formatters } from 'react-data-grid-addons';
import { Link } from 'react-router';
import { 
  Grid, Row, Col, Panel, Button, DropdownButton, ButtonToolbar, MenuItem, 
  FieldGroup, Input,  Breadcrumb,
} from 'react-bootstrap';
import moment from 'moment';
import _ from 'lodash';
import { Field, FieldArray, reset } from 'redux-form';
import { Translate, Localize } from 'react-redux-i18n';
import { SkyLightStateless } from 'react-skylight';

import { UI_HEIGHT } from '../Common/constants';
import Selection from '../Common/selection';
import { InputField, DisabledInputField, ControlledInputField } from '../Common/inputField';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import CashFormatter from '../Common/cashFormatter';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import SalesInventoryInfo from '../../containers/Sales/salesInventoryInfo';
import ReturnModal from '../../containers/Returns/returnModal';
import SetWeightModal from '../../containers/Dispatch/setWeightModal';
import { isAN, isDHC } from '../../actions/root_url';

const AutoCompleteEditor = Editors.AutoComplete;

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

class CustomerIssueCredit extends Component{
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton - 150,
      invoice: {
        rows: [],
        selectedRows: [],
        filters: {},
        sortColumn: null,
        sortDirection: null,
      },
      totalPrice: 0,
      showInventoryOpen: false,
      currentCustomer_id: null,
      selectedInventoryRow: {},
      curRow: '',
      curTotal: 0,
      curCRV: 0,
      curTax: 0,
      curRestock: 0,
      curNotation: '',
      curFinal: 0,
      totalLoaded: null,
      ReturnFormatter: false,
      IsWeight: false,
      rowChosen: null,
      currentWeights: null,
      backLogWeights: [],
    };
    this.handleResize = this.handleResize.bind(this);
  }

  componentWillMount() {
    if (!this.props.currentCustomer) {
      this.context.router.push('/customerReturn/');
    } else {
      this.setState({ currentCustomer_id: this.props.currentCustomer.id });
    }
    this.props.setDefaultSearchType('RefNum', 'customerIssueCredit');
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    const { currentSalesInvoice } = this.props;

    if(this.props.currentCustomer) {
      this.props.fetchCustomerDetail(this.props.currentCustomer.id);
      this.props.fetchTaxRates();
    }
    // else if(typeof currentSalesInvoice == "object" && currentSalesInvoice && currentSalesInvoice.SalesReturn_id != null){
    //   this.props.fetchSalesReturnDetail(currentSalesInvoice.SalesReturn_id);
    // }
    // else if(typeof currentSalesInvoice == "object" && currentSalesInvoice)
    //   this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice.SalesInvoice_id);
    // else if(currentSalesInvoice)
    //   this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice, "InvoiceNum");
    // this.props.fetchSalesInvoice("1900-01-01", "3000-01-01", null, 7);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.salesInvoiceDetail && nextProps.salesInvoiceDetail != this.props.salesInvoiceDetail) {
      let invoice = { ...this.state.invoice, rows: nextProps.salesInvoiceDetail.Sales_Invoice_Lines || []};
      this.setState({ invoice });
    }
    if (nextProps.taxRates && nextProps.taxRates != this.props.taxRates) {
      let invoice = { ...this.state.invoice, TaxRate: nextProps.taxRates[0].Rate || 0};
      this.setState({ invoice });
    }
  }

  handleResize(e) {
    this.setState({tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton - 150});
  }

  handleOnFocus = (event) => {
    event.target.select();
  }

  setAllProductQuantity = (quantity) => {
    this.props.setValue('salesOrderForm', 'Quantity', quantity);
  }

  selectInventoryInfo = (selectedInventoryRow) => {
    this.setState({
      selectedInventoryRow,
      inStock: selectedInventoryRow.InStock,
      purchased: selectedInventoryRow.Purchased,
      presale: selectedInventoryRow.PreSale,
      net_weight: selectedInventoryRow.NetWeight,
      ship_weight: selectedInventoryRow.NetWeight,
      product_type: selectedInventoryRow.ProductType });
  }

  openShowInventory(event) {
    if (!this.props.searchValue || this.props.searchValue === '') {
      return;
    }
    switch (event.charCode) {
      case 13: // ENTER
        event.preventDefault();
        if (this.props.currentCustomer) {
          this.setState({ showInventoryOpen: true });
          break;
        } else {
          this.setState({ case: 'noCustomerChosen', confirmOpen: true });
          break;
        }
      default:
        break;
    }
  }
  closeShowInventory = (value) => {
    this.handleAfterShowInventoryClose(value);
    this.setState({ showInventoryOpen: false });
  }

  handleAfterShowInventoryClose(value) {
    ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
  }

  handleKeyPress(value, event){
    if(event.charCode == 13){
      event.preventDefault();
      if(value == 'unitPrice' || value == 'notation') {
        if (!isNumeric(this.props.Quantity) ||  this.props.Quantity < 0){
          return;
        }
      }
      ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
    }
  }

  moveToIssueForm = () => {
    let invoice = this.state.invoice;
    const {
      CRV,
      ProductNum,
      Name,
      Description,
      IsTaxable,
      MeasureUnit,
      NetWeight,
      PackageSize,
      PackageType,
      ProductType,
      Product_id,
      RefNum,
      RefPrice,
    } = this.state.selectedInventoryRow;
    const {
      UnitPrice,
      Quantity,
      Weight,
    } = this.props;

    let Total = 0;
    if (ProductType == "Fixed" || ProductType == "Non-Product") {
      if (Quantity) {
          Total = +roundTo((Quantity * UnitPrice), 2).toFixed(2)
      }
    } else {
      if (Weight) {
          Total = +roundTo((Quantity * UnitPrice * Weight), 2).toFixed(2)
      }
    }
    if(isNaN(Total)) {
      Total = 0;
    }
    let newWeightsList = [];
    for (let i = 0; i < Quantity && ProductType !== "Fixed"; i++)
      newWeightsList.push(parseFloat(Weight));
    let newEntry = {
      Idx: (invoice.rows.length) ? invoice.rows[invoice.rows.length - 1].Idx + 1 : 0,
      CRV,
      ProductNum,
      Name,
      Description,
      IsTaxable,
      MeasureUnit,
      NetWeight,
      PackageSize,
      PackageType,
      ProductType,
      Product_id,
      RefNum,
      RefPrice,
      UnitPrice,
      ReturnableWeightsList: newWeightsList,
      Weights: newWeightsList,
      LoadedQuantity: parseFloat(Quantity),
      TotalNetWeight: parseFloat(Weight) * parseFloat(Quantity),
      ReturnQuantity: parseFloat(Quantity),
      ReturnWeight: parseFloat(Weight) * parseFloat(Quantity),
      ReturnTotalPrice: Total,
      ReturnReason: "",
      IsProductReturned: false,
    };
    invoice.rows.push(newEntry);
    this.setState({invoice});
    this.props.resetIssueInputs();
  }

  renderSubtotal() {
    let subtotal = 0;
    if (this.state.selectedInventoryRow.ProductType == "Fixed" || this.state.selectedInventoryRow.ProductType == "Non-Product") {
      if (this.props.Quantity) {
          subtotal = (this.props.Quantity * this.props.UnitPrice).toFixed(2)
      }
    } else {
      if (this.props.Weight) {
          subtotal = (this.props.UnitPrice * this.props.Weight).toFixed(2)
      }
    }
    if(isNaN(subtotal)) {
      subtotal = 0;
    }
    return (
      <Field  name="Subtotal" component={DisabledInputField} placeholder={subtotal}/>
    )
  }

  formatDate(date) {
    let formattedDate = date.getFullYear() + '-';

    formattedDate += date.getMonth()+1 + '-';
    if (date.getDate() < 10) {
      formattedDate += '0' + date.getDate();
    } else {
      formattedDate += date.getDate();
    }
    return formattedDate;
  }

  calculateFinalTotal(nextProps) {
    let Tax = nextProps.Tax;
    let Promo = nextProps.Promo;
    let RestockingFee = nextProps.RestockingFee;

    if (isNumeric(Tax)) {
      Tax = parseFloat(Tax);
    } else {
      Tax = 0;
    }
    if (isNumeric(Promo)) {
      Promo = parseFloat(Promo);
    } else {
      Promo = 0;
    }
    if (isNumeric(RestockingFee)) {
      RestockingFee = parseFloat(RestockingFee);
    } else {
      RestockingFee = 0;
    }

    return Tax + Promo - RestockingFee;
  }

  closeReturnModal = () => { this.setState({ ReturnModalOpen: false, IsWeight: false}); }
  openWeightModule = () => { this.setState({ ReturnModalOpen: true, IsWeight: true }); }
  openQuantityModule = () => { this.setState({ ReturnModalOpen: true, IsWeight: false}); }
  setWeights = (currentRow, currentWeights, editedRow) => {
    let index = 0;
    let Weights = [];
    let ReturnWeight = 0;
    currentWeights.map(row => {
      Weights.push( parseFloat(roundTo(parseFloat(row.Weight), 2).toFixed(2)) );
      ReturnWeight += roundTo(parseFloat(row.Weight), 2);
    });
    const rows = [...this.state.invoice.rows];
    rows[currentRow].Weights = Weights;
    rows[currentRow].ReturnableWeightsList = Weights;
    rows[currentRow].ReturnWeight = ReturnWeight;
    rows[currentRow].ReturnTotalPrice = parseFloat(roundTo(parseFloat(ReturnWeight) * rows[currentRow].UnitPrice, 2)).toFixed(2);
    const invoice = { ...this.state.invoice, rows };
    this.setState({ invoice });
  }

  keepLoaded = (oldLoaded) => {
    let invoice = {...this.state.invoice};
    invoice.rows[this.state.currentRow].ReturnQuantity = oldLoaded;
    this.setState({ invoice });
  }

  returnTotalWeight(totalWeight) {
    console.log("this is the return weight", totalWeight);
  }

  renderInvoice() {
    let that = this;
    if (this.props.isLoading && !this.props.error) {
      return <Spinner/>
    } else if (this.props.error) { 
      return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
    } else {
      // Parameters of the react-data-grid
      const getRows = () => {
        return Data.Selectors.getRows(this.state.invoice);
      }
      const getSize = () => {
        return getRows().length;
      }
      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      }
      // Handle the sortable function
      const handleGridSort = (sortColumn, sortDirection) => {
        var invoice = {...this.state.invoice, sortColumn: sortColumn, sortDirection: sortDirection};
        this.setState({ invoice });
      }
      const handleRowUpdated = (e) => {
        let rows = getRows();//this.state.invoice.rows;
        let returnQuantity = parseFloat(rows[e.rowIdx].ReturnQuantity) || 0;
        Object.assign(rows[e.rowIdx], e.updated);
        if (e.cellKey === "ReturnQuantity" && (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || this.state.invoice.rows[e.rowIdx].ProductType === 'Per-Pound' || this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product')) {
          let invoice = {...this.state.invoice};
          if (invoice.rows[e.rowIdx].LoadedQuantity) {
            invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
          }
          if (parseFloat(e.updated.ReturnQuantity) < 0) {
            invoice.rows[e.rowIdx].ReturnQuantity = 0;
          }
          invoice.rows[e.rowIdx].ReturnQuantity = isAN ? parseFloat(e.updated.ReturnQuantity) : Math.trunc(invoice.rows[e.rowIdx].ReturnQuantity);
          invoice.rows[e.rowIdx].ReturnWeight = (invoice.rows[e.rowIdx].LoadedQuantity) ?
              ((invoice.rows[e.rowIdx].TotalNetWeight/invoice.rows[e.rowIdx].LoadedQuantity) * invoice.rows[e.rowIdx].ReturnQuantity) :
              ((invoice.rows[e.rowIdx].InvoiceWeight/invoice.rows[e.rowIdx].InvoiceQuantity) * invoice.rows[e.rowIdx].ReturnQuantity);
          invoice.rows[e.rowIdx].ReturnWeight = +roundTo(invoice.rows[e.rowIdx].ReturnWeight, 2).toFixed(2);
          if (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed') {
            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
          } else {
            invoice.rows[e.rowIdx].ReturnTotalPrice = (invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].UnitPrice);
          }
          invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnTotalPrice, 2)).toFixed(2);
          invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV / invoice.rows[e.rowIdx].LoadedQuantity) * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2);
          this.setState({ invoice, totalLoaded: invoice.rows[e.rowIdx].LoadedQuantity});
        } else if (e.cellKey == "ReturnQuantity" && this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Fixed') {
          let updated = {...e.updated};
          if (parseFloat(updated.ReturnQuantity) < 0)
            updated.ReturnQuantity = 0;
          Object.assign(rows[e.rowIdx], updated);
          this.setState({currentRow: e.rowIdx, totalLoaded: parseFloat(rows[e.rowIdx].ReturnQuantity), rowChosen: e.rowIdx, currentWeights: rows[e.rowIdx].Weights, editedRow: rows[e.rowIdx]});
          this.openWeightModule();
        }
        if (e.cellKey === 'UnitPrice') {
          let invoice = {...this.state.invoice};
          // Update Return Total Price
          invoice.rows[e.rowIdx].UnitPrice = +parseFloat(roundTo(rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
          if (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product') {
            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
          } else {
            invoice.rows[e.rowIdx].ReturnTotalPrice = (invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].UnitPrice);
          }
          this.setState({ invoice });
        }
        if(e.cellKey == "ReturnReason"){
          let invoice = {...this.state.invoice};
          invoice.rows[e.rowIdx].ReturnReason = e.updated.ReturnReason;
          this.setState({ invoice });
        }
      }

      var returnReasonOptions = [
        { id: 0, title: 'Damaged' },
        { id: 1, title: 'Defective' },
        { id: 2, title: 'Not Needed' },
        { id: 3, title: 'Repair' },
        { id: 4, title: 'Wrong Item' },
        { id: 5, title: 'Other' },
        { id: 6, title: 'Missing' },
        { id: 7, title: 'Out' },
        { id: 8, title: 'Short' },
      ];

      const ReasonEditor = <AutoCompleteEditor options={returnReasonOptions} />;

      const deleteFormatter = React.createClass({
        render() {
          return(
            <span>
              <Button
                bsStyle="danger"
                className="textAlignStyle"
                onClick={() => {
                let invoice = {...that.state.invoice};
                let index = 0;
                for (let i = 0; i < invoice.rows.length; i++){
                  if (this.props.dependentValues.Idx === invoice.rows[i].Idx){
                    index = i;
                  }
                }
                invoice.rows.splice(index, 1);
                that.setState({invoice});
              }}>X</Button>
            </span>
          );
        }
      });

      const onRowsSelected = (rows) => {
        let newRows = this.state.invoice.rows;
        // for (let i = 0; i < newRows.length; i++) {
        //    newRows[i].isSelected = false;
        // }
        let curRow = false;
        rows.map (r => {
          newRows[r.rowIdx].isSelected = true;
          if (!newRows[r.rowIdx].Restock)
            newRows[r.rowIdx].Restock = 0;
        });
        let selectedRows = [...this.state.invoice.selectedRows];
        selectedRows = selectedRows.concat(rows.map(r => r.row));
        let invoice = {...this.state.invoice, rows: newRows, selectedRows: selectedRows};
        this.setState({ invoice });
      }

      const onRowsDeselected = (rows) => {
        let newRows = this.state.invoice.rows;
        rows.map (r => {
          newRows[r.rowIdx].isSelected = false;
        });
        let selectedRows = [...this.state.invoice.selectedRows];
        selectedRows = selectedRows.filter(function(obj){
           return obj.isSelected == true;
        })
        let invoice = {...this.state.invoice, rows: newRows, selectedRows: selectedRows};
        this.setState({
          invoice
        });
      }
      // let reasonEditor = <DropDownEditor options={returnReasonOptions} />;
      // let reasonFormattor = <DropDownFormatter options={returnReasonOptions} value='bug' />;

      const IsFixedFormatter = React.createClass({
        render() {
          if (this.props.dependentValues.ProductType === "Non-Fixed") {
            return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
          } else if (this.props.dependentValues.ProductType === "Per-Pound"){
            return <span>{this.props.value} <label className="label label-primary"><Translate value="per_pound" /></label></span>;
          } else {
            return <span>{this.props.value}</span>;
          }
        }
      });

      const ReturnWeightFormatter = React.createClass({
        render() {
          return (<span>{(this.props.dependentValues.ReturnWeight || this.props.dependentValues.ReturnWeight === 0) ? this.props.dependentValues.ReturnWeight : ''}</span>);
        }
      });

      const StatusFormatter =  React.createClass({
        render() {
          return (<span style={{width: "100%"}}><input type="checkbox" checked={this.props.dependentValues.IsProductReturned} onClick={() => { that.handleProductChange(this.props.dependentValues); }} /></span>);
        }
      });

      const ReturnFormatter = React.createClass({
        render() {
          if(this.props.dependentValues)
            return(this.props.dependentValues.ProductType === 'Fixed') ?
              <span style={{'padding-right':'5px'}}>{(this.props.dependentValues.ReturnQuantity)}{' '}<Button
              bsStyle="warning"
              className="textAlignStyle" style={{ height: '20px', width: '60px', padding: '0px' }}
              disabled={!this.props.dependentValues.isSelected}
              onClick={() => {
                /*var ProductNum = this.props.dependentValues.ProductNum;
                that.removeRow(ProductNum);*/
                let currentWeights = {};
                currentWeights.Weights = [...this.props.dependentValues.ReturnWeightsList, ...this.props.dependentValues.ReturnableWeightsList];
                that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights});
                that.openWeightModule(this.props.dependentValues);
                console.log("check dependentValues", this.props.dependentValues);
              }}><Translate value="change" /></Button></span> :
              <span>{(this.props.dependentValues.ReturnQuantity || this.props.dependentValues.ReturnQuantity === 0) ? this.props.dependentValues.ReturnQuantity : ''}</span>;
          }
      });

      const TotalPriceFormatter = React.createClass({
        render() {
          return (
            (that.props.params.id) ?
              <span>{(this.props.dependentValues.ProductType === 'Fixed') ?
                parseFloat(roundTo(this.props.dependentValues.ReturnQuantity * this.props.dependentValues.UnitPrice, 2)).toFixed(2) :
                parseFloat(roundTo(this.props.dependentValues.ReturnWeight * this.props.dependentValues.UnitPrice, 2)).toFixed(2)
              }</span> :
              <span>{this.props.dependentValues.TotalPrice}</span>
          );
        }
      });

      const columns =[{
            key: 'Delete',
            name: <Translate value="del" />,
            width: 40,
            formatter: deleteFormatter,
            getRowMetaData: (row) => row
          }, {
            key: 'ProductNum',
            name: <Translate value="product_num" />,
            resizable: true,
            sortable: true,
            width: 140,
            filterable: true
          }, {
            key: 'Name',
            name: <Translate value="name" />,
            resizable: true,
            sortable: true,
            width: 140,
            filterable: true,
          }, {
            key: 'Description',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            width: 160,
            filterable: true,
          }, {
            key: 'UnitPrice',
            name: <Translate value="unit_dollarsign" />,
            editable: true,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
            formatter: CashFormatter,
          }, {
            key: 'ReturnQuantity',
            name: <Translate value="return_qty" />,
            resizable: true,
            sortable: true,
            editable: true,
            width: 130,
            filterable: true,
            formatter: IsFixedFormatter,
            getRowMetaData: (row) => row,
          }, {
            key: 'ReturnWeight',
            name: <Translate value="rtn_wt" />,
            resizable: true,
            sortable: true,
            width: 80,
            filterable: true,
            formatter: ReturnWeightFormatter,
            getRowMetaData: (row) => row,
          }, {
            key: 'ReturnTotalPrice',
            name: <Translate value="total_dollarsign" />,
            resizable: true,
            sortable: true,
            width: 100,
            filterable: true,
            formatter: CashFormatter,
          }, {
            key: 'ReturnReason',
            name: <Translate value="return_reason" />,
            resizable: true,
            sortable: true,
            editor: ReasonEditor,
          }, {
            key: 'IsProductReturned',
            name: <Translate value="is_prod_rtnd" />,
            resizable: true,
            sortable: true,
            formatter: StatusFormatter,
            getRowMetaData: (row) => row,
          },
        ];

      return (
        <Row>
          <Col sm={ 12 }>
            <div id="CustomerIssueCredit-dataGrid1">
              <ReactDataGrid
                rowKey='Product_id'
                onGridSort={handleGridSort}
                columns={columns}
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize() }
                onRowUpdated={handleRowUpdated}
                minHeight={this.state.tableHeight}
                onGridRowsUpdate={()=>{console.log("grid row updating")}}
                //enableRowSelect={true}
                enableCellSelect={true}
                // rowSelection={{
                //   showCheckbox: true,
                //   onRowsSelected: onRowsSelected,
                //   onRowsDeselected: onRowsDeselected,
                //   selectBy: {
                //     isSelectedKey: 'isSelected'
                //   }
                // }}
              />
            </div>
          </Col>
        </Row>
      )
    }
  }

  checkValues = (selected) => {
    for(let i = 0; i < selected.length; i++){
      if (!selected[i].ReturnQuantity || selected[i].ReturnQuantity === null || selected[i].ReturnQuantity === 0){
        alert("Quantity cannot be zero or blank, if you want to remove a row please deselect it");
        return false;
      }
    }
    return true;
  }

  handleIssue = (TotalPrice, TaxRate, Tax, CRV, RestockingFee, FinalPrice, Notation) => {
    let ReturnStatus = false;
    for(let i = 0; i < this.state.invoice.rows.length; i++){
      if(!this.state.invoice.rows[i].ReturnReason){
        ReturnStatus = true;
        i = this.state.invoice.rows.length;
      }
    }
    if (!ReturnStatus) {
      this.props.createCreditIssue(
        this.props.currentCustomer.id,
        TotalPrice,
        TaxRate,
        Tax,
        CRV,
        RestockingFee,
        FinalPrice,
        Notation,
        this.state.invoice,
        this.props.PostingDate,
      )
    } else {
      alert('Please specify a Return Reason(s) for issuing credit');
    }
  }

  handleProductChange = (row) => {
    let invoice = {...this.state.invoice};
    for (let i = 0; i < invoice.rows.length; i++){
      if (invoice.rows[i].Idx === row.Idx) {
        invoice.rows[i].IsProductReturned = !invoice.rows[i].IsProductReturned;
      }
    }
    this.setState({invoice});
  }

  handleRestock = (e) => {
    if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
      let curRestock = e.target.value;
      let invoice = {...this.state.invoice};
      this.setState({curRestock, invoice});
    } else if (e.target.value === '') {
      this.setState({curRestock: '' });
    }
  }

  handleNotation = (e) => {
    this.setState({curNotation: e.target.value});
  }

  render() {
    let createDialogInventoryStyle = {
      height: '700px',
      width: '1000px',
      marginLeft: '-28%',
      marginTop: '-20%',
    };
    let createDialogStyleWeight = {
      width: '500px',
      height: '600px',
      top: '45%',
      marginLeft: '-10%',
    };
    const selectInventoryInformation = (<Translate value="select_inventory_information" />);
    const salesInvoiceDetail = (!this.props.params.id) ? this.props.salesInvoiceDetail : this.props.salesReturnDetail;
    if (this.props.salesReturnDetail && this.props.salesReturnDetail.SRNum)
      salesInvoiceDetail.InvoiceNum = (this.props.params.id) ? this.props.salesReturnDetail.SRNum.slice(0, -1) : salesInvoiceDetail.InvoiceNum;
    const { handleSubmit } = this.props;
    let Customer_Name = '';
    if (salesInvoiceDetail) {
      Customer_Name = (salesInvoiceDetail.Name) ? salesInvoiceDetail.Name : salesInvoiceDetail.Deliver_Customer_Name;
    }
    let taxRate = 0;
    let tax = 0;
    let total = 0;
    let CRV = 0;
    let finalPrice = 0;
    taxRate = parseFloat(this.state.invoice.TaxRate) || 0;
    for (let i = 0; i < this.state.invoice.rows.length; i++) {
      total += (this.state.invoice.rows[i].ReturnTotalPrice) ? roundTo(parseFloat(this.state.invoice.rows[i].ReturnTotalPrice), 2) : 0;
      if (this.state.invoice.rows[i].IsTaxable && this.state.invoice.rows[i].ReturnTotalPrice)
        tax += (this.state.invoice.rows[i].ReturnTotalPrice) ? roundTo(parseFloat(this.state.invoice.rows[i].ReturnTotalPrice), 2) : 0;
      CRV += +roundTo(parseFloat(this.state.invoice.rows[i].CRV || 0) * (parseFloat(this.state.invoice.rows[i].ReturnQuantity) || 0), 2).toFixed(2);
    }
    tax = tax*(parseFloat(taxRate || 0) / 100.0);
    tax = parseFloat(roundTo(tax, 2)).toFixed(2);
    total = parseFloat(roundTo(total, 2)).toFixed(2);
    CRV = parseFloat(roundTo(CRV, 2)).toFixed(2);
    finalPrice = parseFloat(roundTo((parseFloat(total) || 0) + (parseFloat(CRV) || 0) + (parseFloat(tax) || 0) - (parseFloat(this.state.curRestock) || 0), 2)).toFixed(2);
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="returns" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="issue_credit" />
          </Breadcrumb.Item>
        </Breadcrumb>
        <ButtonToolbar id="breadcrumbButtonGroup">
          <Button
            bsStyle="success"
            disabled={this.state.invoice.rows.length === 0}
            onClick={()=>{ this.handleIssue(total, taxRate, tax, CRV, this.state.curRestock, finalPrice, this.state.curNotation); }} >
              <span><em className="fa fa-check" /><Translate value="issue_credit" /></span>
          </Button>
          <Button
            bsStyle="danger"
            type="button"
            onClick={() => { this.context.router.push('/customerReturn') }}>
            <em className="fa fa-close"/><Translate value="exit" />
          </Button>
        </ButtonToolbar>
        <Grid id="sales_issue_credit-form" >
          <Row>
            <Col xs={12}>
              <h1><Translate value="issue_credit" /></h1>
            </Col>
          </Row>
          <Row>
            <Col xs={8}>
              <Panel>
                <Row>
                  <Col sm ={3}>
                    <Row>
                      <Col xs={12}>
                        <h3><Translate value="customer" /></h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={6}>
                        <label><Translate value="name" />:</label>
                      </Col>
                      <Col xs={6}>
                        {Customer_Name}
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={6}>
                    <Row>
                      <Col xs={12}>
                        <h3><Translate value="invoice" /></h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={2}>
                        <label><Translate value="no" />:</label>
                      </Col>
                      <Col xs={7}>
                        {salesInvoiceDetail && salesInvoiceDetail.InvoiceNum}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={2}>
                        <label><Translate value="sales" />:</label>
                      </Col>
                      <Col xs={7}>
                        {salesInvoiceDetail && salesInvoiceDetail.Sales_User_Name}
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={3}>
                    <Row>
                      <Col xs={12}>
                        <h3><Translate value="return" /></h3>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={5}>
                        <label><Translate value="no" />:</label>
                      </Col>
                      <Col xs={7}>
                        {salesInvoiceDetail && salesInvoiceDetail.InvoiceNum}
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={5}>
                        <label><Translate value="return_date" />:</label>
                      </Col>
                      <Col xs={7}>
                        <Field name="PostingDate" selected={moment().format("MM-DD-YY")} component={DatePicker} />
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={5}>
                        <label><Translate value="user" />:</label>
                      </Col>
                      <Col xs={7}>
                        {salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name /*right?*/}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Panel>
            </Col>
            <Col xs={4}>
              <Panel>
                <Row>
                  <Col xs={12}>
                    <h3><Translate value="return_details" /></h3>
                  </Col>
                </Row>
                <Row>
                  <Col xs={2}>
                    <Row>
                      <Col xs={12}>
                        <label style={{'display': 'inline-flex'}}><Translate value="total" /><span className="dollar-sign"> $$</span>:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Field name="ReturnTotal" component={DisabledInputField} placeholder={total}/>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={2}>
                    <Row>
                      <Col xs={12}>
                        <label><Translate value="crv" />:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Field name="CRV" component={DisabledInputField} placeholder={CRV} />
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={2}>
                    <Row>
                      <Col xs={12}>
                        <label><Translate value="tax" />:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Field name="Tax" component={DisabledInputField } placeholder={tax}/>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={4}>
                    <Row>
                      <Col xs={12}>
                        <label><Translate value="restocking_fee" />:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Input name="curRestock" type="number" onChange={this.handleRestock} value={this.state.curRestock} />
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={2}>
                    <Row>
                      <Col xs={12}>
                        <label style={{'display': 'inline-flex'}}><Translate value="final" /><span className="dollar-sign"> $$</span>:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Field name="FinalTotal" component={DisabledInputField} placeholder={finalPrice}/>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col xs={8}>
                    <Row>
                      <Col xs={12}>
                        <label><Translate value="notation" />:</label>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12}>
                        <Input name="curNotation" type="text" onChange={this.handleNotation} value={this.state.curNotation} />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Panel>
            </Col>
          </Row>
          <span>
            <h2 style={{'marginTop': '0'}}><Translate value="product_information" /></h2>
          </span>
          <Panel>
            <Row>
              <Col xs={12}>
                <Row>
                  <Col xs={6}>
                    <Field name="searchType" component={ renderTypeRadios } />
                    <div style={{'padding-bottom':'9px'}}></div>
                    <Field name="ProductInformation" component={InputField} ref="productSearch" withRef={true} onFocus={this.handleOnFocus} onKeyPress={(event) => {this.openShowInventory(event)}}/>
                  </Col>
                  <Col xs={ 6 } id="product-search-outputs">
                    <Col xs={ 2 } className="pr0">
                      <label ><Translate value="qty" /></label>
                      <Field name="Quantity" withRef={true} ref="quantity" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                            this.handleKeyPress('unitPrice', event)
                        }} placeholder="must be > 0"/>
                    </Col>
                    <Col xs={ 2 } className="pr0">
                      <label ><Translate value="unit" /><span className="dollar-sign">$$</span></label>
                      <Field name="UnitPrice" withRef={true} ref="unitPrice" component={ InputField } onFocus={this.handleOnFocus} onKeyPress={(event) => {
                        if (event.charCode == 13) {
                          if (!isNumeric(this.props.Quantity) || this.props.Quantity < 0 || !isNumeric(this.props.UnitPrice) || this.props.UnitPrice < 0){
                            return;
                          }
                          this.handleKeyPress('productSearch', event);
                          this.moveToIssueForm();
                        }
                        }}/>
                    </Col>
                    <Col xs={ 2 }>
                      <label><Translate value="net_wt" /></label>
                      <Field 
                        name="Weight"
                        withRef={true}
                        ref="weight"
                        component={ DisabledInputField }
                        onFocus={this.handleOnFocus}
                        onKeyPress={(event) => {
                          if (event.charCode == 13) {
                            this.handleKeyPress('productSearch', event);
                            this.moveToIssueForm();
                          }
                        }}
                      />
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <Col xs={ 12 }>
                          <label ><Translate value="subtotal" /></label>
                        </Col>
                          {this.renderSubtotal()}
                      </Row>
                    </Col>
                    {/* <Col xs={ 4 }>
                      <label><Translate value="notation" /></label>
                      <Field name="itemNotation" withRef={true} ref="notation" component={ InputField } onFocus={this.handleOnFocus} />
                    </Col> */}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Panel>
          <Row>
            <Col xs={12}>
              <Panel>
                { this.renderInvoice() }
              </Panel>
            </Col>
          </Row>
        </Grid>
        <SkyLightStateless dialogStyles={createDialogStyleWeight} isVisible={this.state.ReturnModalOpen} onCloseClicked={() => { this.closeReturnModal(); }} title="Return Products">
          {/* <ReturnModal invoice setWeights={this.setWeights} keepLoaded={()=>{}} currentWeights={this.state.currentWeights} closeC={this.closeReturnModal} totalLoaded={2} rowChosen={this.state.rowChosen} returnTotalWeight={this.returnTotalWeight.bind(this)} /> */}
          <SetWeightModal
            invoice
            setWeights={this.setWeights}
            keepLoaded={this.keepLoaded}
            currentWeights={this.state.currentWeights}
            closeC={this.closeReturnModal}
            totalLoaded={this.state.totalLoaded}
            rowChosen={this.state.rowChosen}
            returnTotalWeight={this.returnTotalWeight.bind(this)}
            editedRow={this.state.editedRow} />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={createDialogInventoryStyle}
          isVisible={this.state.showInventoryOpen}
          onCloseClicked={()=> {this.closeShowInventory('productSearch')}}
          title={selectInventoryInformation}>
          <SalesInventoryInfo
            Customer_id={this.state.currentCustomer_id}
            SearchType={this.props.searchType}
            SearchValue={this.props.searchValue}
            closeShowInventory={this.closeShowInventory}
            selectInventoryInfo={this.selectInventoryInfo}
            setSaleRowValue={this.props.setSaleRowValue}
            setAllProductQuantity={this.setAllProductQuantity}
            formName="customerIssueCredit"
          />
        </SkyLightStateless>
      </ContentWrapper>
    )
  }
}

let renderTypeRadios = props => {
  return (
    <div className="form-group" id="search-product-by">
      <label className="col-xs-4 search-by-max-width">
        <Translate value="search_by" />
      </label>
      <label className="col-xs-2" >
        <input {...props.input} type="radio" value="ProductNum"
          checked={props.input.value === "ProductNum"}/>
        <Translate value="prod_num" />
      </label>
      <label className="col-xs-2">
        <input {...props.input} type="radio" value="RefNum"
          checked={props.input.value === "RefNum"}/>
        <Translate value="ref_num" />
      </label>
      <label className="col-xs-2" >
        <input {...props.input} type="radio" value="Name"
          checked={props.input.value === "Name"}/>
        <Translate value="name" />
      </label>
      <label className="col-xs-2" >
        <input {...props.input} type="radio" value="Description"
          checked={props.input.value === "Description"}/>
        <Translate value="description" />
      </label>
    </div>
  )
}

export default CustomerIssueCredit;

function roundTo(n, digits) {
  if (digits === undefined) {
    digits = 0;
  }

  var multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  var test =(Math.round(n) / multiplicator);
  return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/customerIssueCredit.jsx